import {
  derivePairedChangeRequestPresentation,
  type CanonicalPresentationModelV1,
  type ClientChangeRequestTimelineEntryV1,
} from "@enrein/shared-contracts";

/** Adapter boundary — maps timeline DTO + current preview into shared Client presentation. */
export function deriveClientChangeRequestPresentation(
  entry: ClientChangeRequestTimelineEntryV1,
  presentationScopeId: string,
  currentPreviewVersionId: string | null | undefined,
): CanonicalPresentationModelV1 | null {
  const paired = derivePairedChangeRequestPresentation({
    projectId: presentationScopeId,
    changeRequestId: entry.changeRequestId,
    status: entry.status,
    messagePreview: entry.message,
    createdAt: entry.createdAt,
    startedAt: entry.startedAt,
    resolvedAt: entry.resolvedAt,
    resolvedPreviewVersionId: entry.resolvedPreviewVersionId,
    resolutionMatchesCurrentPassingArtifact:
      entry.status === "RESOLVED" &&
      Boolean(entry.resolvedPreviewVersionId) &&
      entry.resolvedPreviewVersionId === currentPreviewVersionId,
    latestPreviewVersionId: currentPreviewVersionId,
  });
  return paired?.client ?? null;
}
